import React, { Component } from 'react';
import { connect } from 'react-redux';
import Autosuggest from 'react-autosuggest';
import IsolatedScroll from 'react-isolated-scroll';
import { Translate } from 'react-redux-i18n';
import { Row, Col } from 'react-bootstrap';
import _ from 'lodash';
import {
  fetchItemSalesHistory, fetchSalesOrderProductByID, fetchBachesByID,
  fetchProductPromotion, clearSalesOrderFormBatches
} from '../../actions/sales_actions';
import { fetchSalesOrderSuggestions } from '../../actions/autoSuggest_actions';
import {
  ROOT_URL, ROOT_API_URL, companyCodeTitle, isSH, isAP, isDAICHEONG, isHMM, isVIP, isSC,
  isSUN, isLAP, isUSPrideMulti, isAPD, isGGI, isCPG, isOLG, isOCM, isSV, isEKC, isLMH, isBRO, isCRW, isSDR, isVAK, isGFD
} from '../../actions/root_url';
import { wrapLongWord } from '../../utils';

/* ----------- */
/*    Utils    */
/* ----------- */

// https://developer.mozilla.org/en/docs/Web/JavaScript/Guide/Regular_Expressions#Using_Special_Characters
function escapeRegexCharacters(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

/* --------------- */
/*    Component    */
/* --------------- */

const styles = {
  nameStyle: {
    fontSize: '12px'
  }
}

class SalesOrderAutoSuggest extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: '',
      suggestions: [],
      CustomerNumber: null,
      noSuggestions: false,
    };

    this.lastRequestId = null;
    // this.onSuggestionsFetchRequested = _.throttle(({ value }) => {
    //   this.loadSuggestions(value);
    // }, 200);
    this.onSuggestionsFetchRequested = _.debounce(({ value }) => {
      this.loadSuggestions(value);
    }, 600, { maxWait: 800 });
  }

  componentWillMount() {
    let CustomerNumber = this.props.CustomerNumber;
    if (this.props.CustomerNumber && this.props.CustomerNumber.value) {
      CustomerNumber = this.props.CustomerNumber.value;
    }
    this.setState({ CustomerNumber });
  }

  componentWillReceiveProps(nextProps) {
    const isInputBlank = nextProps.value === '';
    const noSuggestions = !isInputBlank && nextProps.salesOrderSuggestions.length === 0;
    this.setState({ noSuggestions });
    if (nextProps.CustomerNumber && nextProps.CustomerNumber !== this.props.CustomerNumber) {
      let CustomerNumber = nextProps.CustomerNumber;
      if (nextProps.CustomerNumber && nextProps.CustomerNumber.value) {
        CustomerNumber = nextProps.CustomerNumber.value;
      }
      this.setState({ CustomerNumber });
    }

    if (nextProps.salesOrderSuggestions !== this.props.salesOrderSuggestions) {
      this.setState({
        suggestions: isOLG ? [...nextProps.salesOrderSuggestions] : [...(nextProps.salesOrderSuggestions).slice(0, 200)],
      });
      // if (this.props.SearchType === 'Barcode' && nextProps.salesOrderSuggestions.length === 1) {
        // selectInventoryInfo get info
        // this.props.fetchSalesOrderProductByID(nextProps.salesOrderSuggestions[0].Product_id, this.state.CustomerNumber, this.props.selectedCompany ? this.props.selectedCompany.value : null);
        // this.props.fetchSalesOrderProductByID(nextProps.salesOrderSuggestions[0].Product_id, this.state.CustomerNumber, this.props.Company_id, this.props.Pickup_Warehouse_id);
        // this.props.fetchItemSalesHistory(this.state.CustomerNumber, nextProps.salesOrderSuggestions[0].Product_id);
        // this.props.handleFocusQty();
      // }
    }
  }

  onChange = (event, { newValue }) => {
    this.props.clearSalesOrderFormBatches();
    this.setState({
      value: newValue,
    });
  };

  onChange2 = (event, { newValue }) => {
    if ( !(event.keyCode === 40 || event.keyCode===38) ) {
      this.setState({suggestions: []});
    }
    this.props.onChange(event, { newValue });
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  onFocus(event) {
    event.target.select();
  }

  onSuggestionSelected = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) => {
    // function to get product here
    event.stopPropagation();
    event.preventDefault();

    if ((isEKC || isLMH || isBRO) && suggestion && suggestion.ProductNum) {
      this.props.setProdNum(suggestion.ProductNum.slice(0,4));
    }

    if ((isEKC || isLMH || isBRO || isSDR || isCRW || isSC) && suggestion && (suggestion.IsCombo === true || suggestion.IsCombo === 'true')) {
      this.props.setIsCombo(true);
    } else {
      this.props.setIsCombo(false);
    }

    this.props.fetchSalesOrderProductByID(suggestion.Product_id, this.state.CustomerNumber, this.props.Company_id, this.props.Pickup_Warehouse_id);
    this.props.fetchBachesByID(suggestion.Product_id, this.props.Company_id, this.props.Pickup_Warehouse_id);
    this.props.fetchProductPromotion(suggestion.Product_id, this.props.Company_id, this.state.CustomerNumber);
    this.props.fetchItemSalesHistory(this.state.CustomerNumber, suggestion.Product_id);
    if(isGGI) {
      this.props.setConvertedMaxStock(suggestion.InStock - suggestion.PreSale);
    } else {
      this.props.setConvertedMaxStock(suggestion.InStock);
    }
    setTimeout(() => {
      this.props.handleFocusQty();
    }, 500);
  }

  onKeyPress = () => {
    return false;
    // this.props.handleKeyPress('quantity', event);
  }

  getSuggestionValue = (suggestion) => {
    if (isEKC || isLMH || isBRO || isSDR || isCRW || isSC) {
      return `${suggestion.RefNum} | ${suggestion.Name}`;
    }

    switch (this.props.SearchType) {
      case 'ProductNum':
        return `${suggestion.ProductNO} | ${suggestion.Name}`;
      case 'RefNum':
        return `${suggestion.RefNum} | ${suggestion.Name}`;
      case 'Name':
        return suggestion.Name;
      case 'Description':
        return `${suggestion.Description} | ${suggestion.Name}`;
      case 'GeneralNum':
        return `${suggestion.GeneralNum} | ${suggestion.Name}`;
      case 'Barcode':
        return `${suggestion.ProductNO} | ${suggestion.Name}`;
      default:
        return null;
    }
  }

  loadSuggestions(value) {
    // if (value.length < 3) {
    //   return;
    // }
    // Cancel the previous request
    // if (this.lastRequestId !== null) {
    //   clearTimeout(this.lastRequestId);
    // }

    // this.setState({
    //   isLoading: true,
    //   suggest: [],
    // });


    // Fake request
    // this.lastRequestId = setTimeout(() => {
    if (this.state.CustomerNumber == null) {
      return;
    }
    // this.props.fetchSalesOrderSuggestions(this.state.CustomerNumber, this.props.SearchType, value, this.props.selectedCompany ? this.props.selectedCompany.value : null);
    this.props.fetchSalesOrderSuggestions(this.state.CustomerNumber, this.props.SearchType, value, this.props.Company_id, this.props.Pickup_Warehouse_id, this.props.color, this.props.pkgTp);
    // axios.get(`${ROOT_URL}v1/inventory/sales_order/search/simplified/${this.state.CustomerNumber}/?${this.props.SearchType}=${value}`,
    // {
    //     headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
    // })
    // .then(response => {
    //   const suggestionData = [...response.data];
    // this.setState({
    //   isLoading: false,
    //   suggestions: suggestionData,
    // });
    // }, err => {
    //   // if (err.status === 500 || err.status === 404) {
    //   //   err.data = DEFAULT_ERROR;
    //   // }
    //   console.log('error occured in search', err);
    // });
    // }, 100);
  }

  renderErrorMessage() {
    const { noSuggestions } = this.state;
    if (noSuggestions && !this.props.salesOrderSuggestionsIsLoading) {
      return (
        <div className="no-suggestions">
          <Translate value="no_data_found" />
        </div>
      );
    }
    return <div />;
  }

  renderSearchTypeValue(suggestion) {
    switch (this.props.SearchType) {
      case 'ProductNum':
        return suggestion.ProductNO;
      default:
        return suggestion.RefNum;
    }
  }

  renderSuggestion = (suggestion) => {
    const isInternal = this.props.salesShippingCustomerDetails ? this.props.salesShippingCustomerDetails.isInternal : false;
    const renderPrice = () => {
      if (isInternal && isOCM) {
        return suggestion.ArrivalPrice
      }
      return suggestion.Price
    }
    if(isSH || isAP) {
      return <Row
        // className="suggestion"
        id="suggestion-render"
        className="sales-auto-suggest-suggestions"
        style={{ fontSize: '10px' }} // style={isHMM ? { fontSize: '13px' } : {}}
      >
        <Col xs={3} style={{fontSize: '14px'}}>
          {suggestion.Name}
        </Col>
        <Col xs={1}>
          {suggestion.InStock}
        </Col>
        <Col xs={5}>
          {suggestion.Description}
        </Col>
        <Col xs={3}>
          {suggestion.Color}
        </Col>
      </Row>
    }
    if (isSV) {
      return <Row
        id="suggestion-render"
        className="sales-auto-suggest-suggestions"
        style={{ fontSize: isHMM ? '13px' : '15px' }} // style={isHMM ? { fontSize: '13px' } : {}}
      >
        <Col xs={1}>
          {this.renderSearchTypeValue(suggestion)}
        </Col>
        <Col xs={1}>
          {suggestion.RefNum}
        </Col>
        <Col xs={3} style={{backgroundColor: suggestion.IsDiscontinued ? 'red' : 'transparent'}}>
          {suggestion.Name}
        </Col>
        <Col xs={1}>
          {suggestion.InStock}
        </Col>
        <Col xs={2} id="price-col">
          {suggestion.PromoPrice1 + ' / ' + suggestion.PromoPrice2 + ' / ' + suggestion.PromoPrice3}
        </Col>
        <Col xs={1}>
          {suggestion.PromoTier1Qty + ' / ' + suggestion.PromoTier2Qty}
        </Col>
        <Col xs={1}>
          {suggestion.MinOrderQty}
        </Col>
        <Col xs={1}>
          {(suggestion.IsCombo === true) ? "true" : "false"}
        </Col>
      </Row>
    }

    return <Row
      id="suggestion-render"
      className="sales-auto-suggest-suggestions"
      style={{ fontSize: isHMM ? '13px' : '15px' }}
    >
      <Col xs={(isLMH || isBRO || isSDR || isCRW || isSC) ? 2 : 1}>
        {isOLG?<span style={styles.nameStyle}>{suggestion.RefNum}</span>: this.renderSearchTypeValue(suggestion)}
      </Col>
      {isSUN &&
        <Col xs={2}>
          {suggestion.GeneralNum}
        </Col>
      }
      {!isOLG && <Col xs={(isLAP || isUSPrideMulti || isAPD || isCPG || isVIP) ? 3 : 2}>
        {suggestion.Name}
      </Col>}
      {(!isLAP && !isUSPrideMulti && !isAPD && !isSDR && !isCRW && !isSC) &&<Col xs={(isLMH || isBRO) ? 4 : (isEKC) ? 3 : (isSUN || isCPG || isGGI || isVIP) ? 1 : 2}>
      {isOLG ? <span style={styles.nameStyle}>{wrapLongWord(suggestion.Description, 17)}</span> :suggestion.Description}
      </Col>}
      {(isSDR || isCRW || isSC) && <Col xs={2}>
        {<span style={styles.nameStyle}>{suggestion.Brand}</span>}
      </Col> }
      {(isSDR || isCRW || isSC) && <Col xs={2}>
        {<span style={styles.nameStyle}>{suggestion.Color}</span>}
      </Col> }
      {(!isEKC && !isLMH && !isBRO && !isSDR && !isCRW && !isSC) &&
      <Col xs={(isLAP || isUSPrideMulti || isAPD || isGGI || isCPG || isVIP) ? 1 : 2}>
        {isOLG?<span style={styles.nameStyle}>{suggestion.PackageSize}</span>: suggestion.PackageSize}
      </Col>
      }
      <Col xs={1} id="price-col">
        {renderPrice()}
      </Col>
      {(!isEKC && !isHMM && !isLMH && !isBRO && !isSDR && !isCRW && !isSC) &&
        <Col xs={1}>
          {suggestion.NetWeight}
        </Col>
      }
      {(!isDAICHEONG && !isEKC && !isLMH && !isBRO && !isSDR && !isCRW && !isSC && !isSUN && !isHMM) &&
        <Col xs={1}>
          {suggestion.ShippingWeight}
        </Col>
      }
      {/* here */}
      <Col xs={1}>
        {suggestion.InStock}{(isGFD && suggestion.ProductType === 'Fixed') ? "" : isGFD ? "(cs)" : ""}
      </Col>
      {
        !(isCPG || isLMH || isBRO || isSDR || isCRW || isVIP || isSC) &&
        <Col xs={1}>
          {suggestion.InStockCompany}{(isGFD && suggestion.ProductType === 'Fixed') ? "" : isGFD ? "(cs)" : ""}
        </Col>
      }
      {(!isSUN) &&
        <Col xs={1}>
          {suggestion.Purchased}
        </Col>
      }
      {(!isSUN) &&
        <Col xs={1}>
          {suggestion.PreSale}
        </Col>
      }
    </Row>
  }

  renderSearchTypeHeader = () => {
    switch (this.props.SearchType) {
      case 'ProductNum':
        return <Translate value="prod_num" />;
      default:
        return <Translate value={isOLG ? "item_no" : isVAK ? "sku" :  "ref_num"} />;
    }
  }

  renderSuggestionsContainer = ({ containerProps, children }) => {
    const { ref, ...restContainerProps } = containerProps;
    const callRef = scrollingDiv => {
      if (scrollingDiv !== null) {
        ref(scrollingDiv.component);
      }
    };
    if(isSH || isAP) {
      return <div {...restContainerProps} >
        <div className="container" style={{ width: '100%' }} id="suggestion-container">
          <Row style={{ padding: '10px 5px', margin: '0px' }} className="sales-auto-suggest-suggestions" id="sales-auto-suggest-header">
            <Col xs={3}>
              <Translate value="prod_name" />
            </Col>
            <Col xs={1}>
              <Translate value="instock" />
            </Col>
            <Col xs={5}>
              <Translate value="desc" />
            </Col>
            <Col xs={3}>
              <Translate value="color" />
            </Col>
          </Row>
        </div>
        <IsolatedScroll id="suggestions-customer-container" ref={callRef}>
          {children}
        </IsolatedScroll>
      </div>
    }
    if (isSV) {
      return <div {...restContainerProps} >
      <div className="container" style={{ width: '100%' }} id="suggestion-container">
        <Row style={{ padding: '10px 5px', margin: '0px' }} className="sales-auto-suggest-suggestions" id="sales-auto-suggest-header">
          <Col xs={1}>
            {this.renderSearchTypeHeader()}
          </Col>
          <Col xs={1}>
            <Translate value="item_num" />
          </Col>
          <Col xs={3}>
            <Translate value="prod_name" />
          </Col>
          <Col xs={1}>
            <Translate value="stock" />
          </Col>
          <Col xs={2} id="price-col">
            <Translate value="unit_dollarsign" />
          </Col>
          <Col xs={1}>
            <Translate value="promo_qty" />
          </Col>
          <Col xs={1}>
            <Translate value="min_qty" />
          </Col>
          <Col xs={1}>
            <Translate value="is_combo" />
          </Col>
        </Row>
      </div>
      <IsolatedScroll id="suggestions-customer-container" ref={callRef}>
        {children}
      </IsolatedScroll>
    </div>
    }
    return (
      <div {...restContainerProps} >
        <div className="container" style={{ width: '100%' }} id="suggestion-container">
          <Row style={{ padding: '10px 5px', margin: '0px' }} className="sales-auto-suggest-suggestions" id="sales-auto-suggest-header">
            <Col xs={(isLMH || isBRO || isSDR || isCRW || isSC) ? 2 : 1}>
              {this.renderSearchTypeHeader()}
            </Col>
            {isSUN &&
              <Col xs={2}>
                <Translate value="general_num" />
              </Col>
            }
            {!isOLG && <Col xs={(isLAP || isUSPrideMulti || isAPD || isCPG || isVIP) ? 3 : 2}>
              <Translate value="prod_name" />
            </Col>}
            {(!isLAP && !isUSPrideMulti && !isAPD && !isSDR && !isCRW && !isSC) &&
              <Col xs={(isLMH || isBRO) ? 4 : (isEKC) ? 3 : (isSUN || isCPG || isGGI || isVIP) ? 1 : 2}>
                <Translate value="desc" />
              </Col>
            }
            {(isSDR || isCRW || isSC) &&
              <Col xs={2}>
                <Translate value="brand" />
              </Col>
            }
            {(isSDR || isCRW || isSC) &&
              <Col xs={2}>
                <Translate value="color" />
              </Col>
            }
            {(!isEKC && !isLMH && !isBRO && !isSDR && !isCRW && !isSC) &&
              <Col xs={(isLAP || isUSPrideMulti || isAPD || isGGI || isCPG || isVIP) ? 1 : 2}>
                <Translate value="pkg_size" />
              </Col>
            }
            <Col xs={1} id="price-col">
              <Translate value="unit_dollarsign" />
            </Col>
            {(!isEKC && !isLMH && !isBRO && !isHMM) &&
              <Col xs={1}>
                <Translate value="net_wt" />
              </Col>
            }
            {(!isDAICHEONG && !isEKC && !isLMH && !isBRO && !isSDR &&!isCRW && !isSC && !isSUN && !isHMM) &&
              <Col xs={1}>
                <Translate value="ship_wt" />
              </Col>
            }
            <Col xs={1}>
              <Translate value="instock" />
            </Col>
            {!(isCPG || isLMH || isBRO || isSDR || isCRW || isVIP || isSC) &&
              <Col xs={1}>
                <Translate value="instock_co" />
              </Col>
            }
            {!isSUN &&
              <Col xs={1}>
                <Translate value="purchased" />
              </Col>
            }
            {!isSUN &&
              <Col xs={1}>
                <Translate value="presale" />
              </Col>
            }
          </Row>
        </div>
        <IsolatedScroll id="suggestions-customer-container" ref={callRef}>
          {children}
        </IsolatedScroll>
      </div>
    );
  }

  render() {
    const { suggestions } = this.state;
    const { SearchType } = this.props;
    const inputProps = {
      value: this.props.value,
      onChange: this.onChange2,
      onKeyPress: this.onKeyPress,
      onFocus: this.onFocus,
      id: 'sales-auto-suggest',
    };
    return (
      <div>
        <Autosuggest
          suggestions={suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          focusInputOnSuggestionClick={false}
          getSuggestionValue={this.getSuggestionValue}
          renderSuggestion={this.renderSuggestion}
          renderSuggestionsContainer={this.renderSuggestionsContainer}
          onSuggestionSelected={this.onSuggestionSelected}
          highlightFirstSuggestion
          inputProps={inputProps}
        />
        {this.renderErrorMessage()}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    salesOrderSuggestions: state.autoSuggest.salesOrderSuggestions,
    salesOrderSuggestionsIsLoading: state.autoSuggest.salesOrderSuggestionsIsLoading,
    salesOrderSuggestionsError: state.autoSuggest.salesOrderSuggestionsError,
    // selectedCompany: state.header.selectedCompany,
  };
}

export default connect(mapStateToProps, { clearSalesOrderFormBatches, fetchSalesOrderProductByID, fetchItemSalesHistory, fetchSalesOrderSuggestions, fetchBachesByID, fetchProductPromotion })(SalesOrderAutoSuggest);



// WEBPACK FOOTER //
// ./master/jsx/components/Common/SalesOrderAutoSuggest.jsx